import React from 'react';
import PropTypes from 'prop-types';
import LogLineContent from './LogLineContent';
import projectLogsKeeper from '../../../services/dataKeepers/ProjectLogsKeeper';
import { TODAY_LOG_SEPARATOR_TOP, TODAY_LOG_SEPARATOR_BOTTOM, MODEL_UPDATED_LOG_SEPARATOR } from '../../../services/mini/insertTodayLogSeprator';

class LogLine extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.toggleJsonData = this.toggleJsonData.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        let curProps = this.props;

        if (curProps.log && nextProps.log && curProps.log.id !== nextProps.log.id) {
            return true;
        }

        if (curProps.isNew !== nextProps.isNew) {
            return true;
        }

        if (curProps.maxLineLog !== nextProps.maxLineLog) {
            return true;
        }

        if (curProps.maxScriptName !== nextProps.maxScriptName) {
            return true;
        }

        if (curProps.hasAudioPreview !== nextProps.hasAudioPreview) {
            return true;
        }

        if (curProps.hasImagePreview !== nextProps.hasImagePreview) {
            return true;
        }

        if (curProps.filterUpdateTs !== nextProps.filterUpdateTs) {
            return true;
        }

        return false;
    }

    toggleJsonData(e) {
        const { log, openLogTooltipCb } = this.props;
        projectLogsKeeper.logInTooltip = log;
        openLogTooltipCb();
    }

    render() {
        let {
            log,
            logKey,
            isNew,
            maxLineLog,
            maxScriptNameWidth,
            setFilterByPhraseCb,
            hasAudioPreview,
            hasImagePreview,
            filterUpdateTs,
            filters
        } = this.props;

        if (log.id === MODEL_UPDATED_LOG_SEPARATOR) {
            return <div className="model-was-updated-separator">Model was updated</div>;
        }

        if (log.id === TODAY_LOG_SEPARATOR_TOP) {
            return <div className="log-line-separator log-line-separator__top"><div className="log-line-separator__label">Today</div></div>;
        }

        if (log.id === TODAY_LOG_SEPARATOR_BOTTOM) {
            return <div className="log-line-separator log-line-separator__bottom"></div>;
        }

        return <LogLineContent
            log={log}
            isNew={isNew}
            filterUpdateTs={filterUpdateTs}
            filters={filters}
            logKey={logKey}
            maxLineLog={maxLineLog}
            maxScriptNameWidth={maxScriptNameWidth}
            hasAudioPreview={hasAudioPreview}
            hasImagePreview={hasImagePreview}
            showJsonData={false}
            goToCb={this.props.goToCb}
            onToggleJsonDataCb={this.toggleJsonData}
            setFilterByPhrase={setFilterByPhraseCb}
            intentLinkMode={this.props.intentLinkMode}
            onJsonObjClick={this.props.onJsonObjClick}
            environment={this.props.environment}
        />;
    }
}

LogLine.propTypes = {
    log: PropTypes.object.isRequired,
    goToCb: PropTypes.func.isRequired,
};

export default LogLine;
